(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearContactosSectorEdDetailController",
            LebaniegoYearContactosSectorEdDetailController
        );

    LebaniegoYearContactosSectorEdDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "LebaniegoYearContactosSectorEd",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "$http",
        "Upload",
    ]

    function LebaniegoYearContactosSectorEdDetailController(
        $mdDialog,
        entity,
        Principal,
        LebaniegoYearContactosSectorEd,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        $http,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearContactosSectorEd = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updatetree = false;
        vm.nodes = [];

        vm.actualSector = vm.lebaniegoYearContactosSectorEd.businessName;
        
        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        })
        Principal.hasAuthority("ROL_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        })

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosSectorEd = Object.assign({}, vm.lebaniegoYearContactosSectorEd);

            LebaniegoYearContactosSectorEd.update(lebaniegoYearContactosSectorEd, onSaveSuccess, onError);
        }

        function onSaveSuccess(result) {
            vm.actualSector = vm.lebaniegoYearContactosSectorEd.businessName;
            toastr.success("Guardada con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();